import React, { FC } from 'react';

import { Checkbox } from '../Checkbox/Checkbox';
import { RadioButton } from '../RadioButton/RadioButton';
import { Switch } from '../Switch/Switch';
import { Typography } from '../Typography/Typography';

import { SelectionControlsProps } from './SelectionControls.types';

import { Info } from '../Icons/Paths/Info';
import Tooltip from '../Tooltip/Tooltip';
import styles from './Styles/Default.module.css';

export const SelectionControls: FC<SelectionControlsProps> = React.forwardRef<
  HTMLDivElement,
  SelectionControlsProps
>(
  (
    {
      checked,
      onChange,
      disabled,
      description,
      error,
      dataTestId,
      className,
      label,
      type,
      isTooltip,
      toolTipText,
      toolTipClassName,
      customTooltipTextClassName,
      ...otherProps
    },
    ref,
  ) => {
    const commonProps = {
      className: `sc-input-${type}`,
      checked,
      disabled,
      onChange,
    };

    const canShowDesc = description && type === 'switch';
    const canShowError = error && type !== 'switch' && !disabled;

    return (
      <div
        className={`${styles.wrapper} ${type === 'switch' ? styles.hasSwitch : ''} ${
          canShowDesc ? styles.hasDesc : ''
        } ${disabled ? styles.isDisabled : ''} ${className ? className : ''}`}
        data-test-id={dataTestId}
        ref={ref}
      >
        {isTooltip && (
          <Tooltip
            text={toolTipText}
            dialogId="buyOnlineToggleInfo"
            requestPos="left-top"
            className={toolTipClassName}
            customTooltipTextClassName={customTooltipTextClassName}
          >
            <Info fontSize={24} />
          </Tooltip>
        )}
        <label className="typography-subheading-4">
          {type === 'checkbox' && <Checkbox {...commonProps} error={!!error} {...otherProps} />}
          {type === 'radio' && <RadioButton {...commonProps} error={!!error} {...otherProps} />}
          {label}

          {type === 'switch' && <Switch {...commonProps} />}
        </label>
        {canShowDesc && (
          <Typography Component="span" className={styles.desc} variant="body4">
            {description}
          </Typography>
        )}
        {canShowError && (
          <Typography Component="span" className={styles.error} variant="caption2" role="alert">
            {error}
          </Typography>
        )}
      </div>
    );
  },
);

SelectionControls.displayName = 'SelectionControls';

export default SelectionControls;
